<template>
<v-layout justify-center>
<v-data-table
:headers="headers"
:items="ensayos"
sort-by="numeroEnsayo"
class="elevation-1"
>
<template v-slot:top>
  <v-toolbar flat color="white">
    <v-toolbar-title>Listado de ensayos</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="![1,2].some(r => usuario.groups.includes(r))"
          color="primary"
          class="mb-2"
          v-bind="attrs"
          v-on="on"
        ><v-icon dark left>mdi-plus</v-icon>Nuevo ensayo</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Nuevo ensayo</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.number" label="Ingrese número"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.name" label="Ingrese nombre"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group column>
                  <v-radio label="Comenzar desde cero" value="radio-1" @click="hidePick"></v-radio>
                  <v-radio label="Replicar otro ensayo" value="radio-2" @click="showPick"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-show="pickList">
              <v-col>

                    <v-text-field
                      v-model="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>

                  <v-data-table
                    v-model="selected"
                    :headers="pickerHeaders"
                    :items="ensayos"
                    :single-select="singleSelect"
                    item-key="nombreEnsayo"
                    show-select
                    class="elevation-1"
                    :items-per-page="5"
                    :search="search"
                  >
                  </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>
<template v-slot:item.nombreEnsayo="{ item }">
  <router-link :to="'detalle/' + item.id">{{item.nombreEnsayo}}</router-link>
</template>
<template v-slot:item.ensayoInicio="{ item }">
  <v-icon v-if="item.ensayoInicio===true" small class="mr-2">mdi-check</v-icon>
  <v-container v-else>
  </v-container>
</template>
<template v-slot:item.actions="{ item }">
  <v-icon
    :disabled="![1,2].some(r => usuario.groups.includes(r))"
    small
    @click="deleteItem(item)"
  >
    mdi-delete
  </v-icon>
</template>
<template v-slot:no-data>
  No hay datos
</template>
</v-data-table>
</v-layout>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      pickList: false,
      singleSelect: true,
      selected: [],
      search: '',
      active: false,
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: true,
          value: 'numeroEnsayo',
        },
        { text: 'Nombre', value: 'nombreEnsayo' },
        { text: 'Inicio', value: 'ensayoInicio' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pickerHeaders: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'nombreEnsayo',
        },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        number: undefined
      },
      defaultItem: {
        name: '',
        number: undefined
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      prueba() {
        return this.$store.state.prueba
      },
      ensayos() {
        return this.$store.state.ensayos
      },
      rules() {
        return [
          this.selected.length > 0 || "At least one item should be selected"
        ];
      },
      usuario() {
        return this.$store.state.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize(),
      this.$store.dispatch('loadEnsayos',{id: this.prueba.id})
    },

    methods: {
      initialize () {
        this.desserts = [
        ]
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.$store.dispatch('deleteEnsayo', {
          'id': this.prueba.id,
          'item': item
        });
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.selected = [];
      },

      save () {
        this.$store.dispatch('createEnsayo', {
          'id': this.prueba.id,
          'item': this.editedItem,
          'selected': this.selected
        });
        console.log(this.editedItem);
        this.selected = [];
        this.close()
      },

      hidePick () {
        this.pickList = false;
        this.selected = [];
      },

      showPick () {
        this.pickList = true;
      },
    },
  }
</script>

<style scoped>
</style>
